export default "__VITE_ASSET__76655747__"